import { Box, Button, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Hero from '@/pages/components/Hero';
import { useNavigate } from 'react-router-dom';

function PageNotFound() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('page-not-found');

  const lang = i18n.language === 'de-CH' ? 'de' : 'fr';

  return (
    <Hero>
      <Container
        sx={{
          textAlign: 'left',
          width: '100%',
          marginTop: 'auto',
          marginBottom: 'auto'
        }}
      >
        <Typography
          variant="h1"
          color="white"
          fontWeight={800}
          sx={{
            fontSize: { xs: '32px', sm: '34px', md: '46px', lg: '58px', xl: '62px' },
            lineHeight: { xs: '1.3', sm: '1.4', lg: '1.2', xl: '1.1' }
          }}
        >
          {t('title')}
        </Typography>
        <Typography
          variant="body1"
          color="white"
          sx={{
            fontSize: '20px',
            lineHeight: '30px',
            marginBottom: '16px'
          }}
        >
          {t('message')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            width: { xs: '100%', md: '50%' }
          }}
        >
          <Button
            variant="contained"
            size="large"
            sx={{
              borderRadius: '8px',
              backgroundColor: 'white',
              color: 'primary.main',
              textTransform: 'none',
              fontSize: '18px',
              '&:hover': {
                backgroundColor: '#f0f0f0'
              }
            }}
            onClick={() => navigate(`/${lang}`)}
          >
            {t('go-back-to-homepage')}
          </Button>
        </Box>
      </Container>
    </Hero>
  );
}

export default PageNotFound;
